

<template>
  <ul class="header_tools">
    <!-- Login Area 
    <li class="d-none d-lg-inline-block">
      <router-link to="/pages/login">Login</router-link>
    </li>
    <li class="d-lg-none">
      <router-link to="/pages/login">
        <i class="far fa-user"></i>
      </router-link>
    </li>
    <li>
      <router-link to="/shop/cart" class="cart_count">
        <img v-bind:src="setShoppingCartImg" alt="shopping bag"/>
        <span>{{ cartTotal }}</span>
      </router-link>
    </li>
    -->
  </ul>
</template>
<script>
import {mapState} from 'vuex';

export default {
  name: 'TopMenuTools',
  data() {
    return {
      shoppingCartImg: {
        black: require('../../assets/img/shopping-bag-black.svg'),
        white: require('../../assets/img/shopping-bag.svg')
      }
    }
  },
  computed: {
    ...mapState({
      cartTotal: function (state) {
        return state.carts.items.length;
      }
    }),
    setShoppingCartImg() {
      if (this.$route.path === "/") {
        return this.shoppingCartImg.white;
      }

      return this.shoppingCartImg.black;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menus/TopMenuTools.vue